import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BabafeszkeloComponent } from './babafeszkelo/babafeszkelo.component';


const routes: Routes = [
    {path:"", component: BabafeszkeloComponent}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BabafeszkelokurzusRoutingModule { 

}
